import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import {questionnaireActions} from "_actions";
import { history } from '_helpers/history'
import {Button, Modal, Radio} from 'antd';
import "../../startCeiba.scss";
import {
    ArrowRightOutlined,
    EditOutlined,
    ReloadOutlined
} from "@ant-design/icons";
import Headerbutton from "../../../component/headerButton";
import localOrSessionStore from "../../../../../_helpers/localOrSessionStore";
import variables from "../../../../../_constants/variables";
import report from '../../../../../assets/img/report.png';
import {xcService} from "../../../../../_services/xcService";

function EndNogam5(props) {

    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} = useTranslation();
    const [data, setData] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [responses, setResponses] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalItem, setModalItem] = useState();
    const [assessment, setAssessment] = useState();
    const [points, setPoints] = useState(0)
    const responsesData = useSelector((state) => state.questionnaireReducer.responsesData);
    const answersData = useSelector((state) => state.questionnaireReducer.answersData);
    const answersDataError = useSelector((state) => state.questionnaireReducer.answersDataError);
    const assestmentsCodeData = useSelector((state) => state.questionnaireReducer.assestmentsCodeData);
    const studentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);
    var saveAnswer = useSelector((state) => state.questionnaireReducer.saveAnswer);
    const retrieveResponse = async (id,answerId)=> {
        let apiEndpoint = "/v1/response/assessment/"+id;
        const res = await xcService.getToken(apiEndpoint);
        return res.data.data.find(res=>res.id===answerId);
    }

    useEffect(() => {
        if (assestmentsCodeData) {
            setData(assestmentsCodeData);
        }
    }, [assestmentsCodeData]);

    useEffect(() => {
            if(!(data&&answers.length>0)) return;
            const res = data.filter(item=>item.questionType==="SINGLE")
                .map(item=> {
                    let mAnswer = answers.find(it => it.assessment_id === item.id);
                    return retrieveResponse(item.id,mAnswer.points)
                })
            Promise.all(res).then((reses)=> {
                    setResponses(reses.filter(it => it))
                }
            );
        },
        [data,answers]
    )
    useEffect(() => {
        if (answersData){
            setAnswers(answersData);
            if (data && data.length) {
                if (answersData.length === data.length) {
                    history.push("/admin/end-nogam5")
                }
            }
        }
    },[answersData,answersDataError])

    useEffect(() => {
        dispatch(questionnaireActions.getAssessmentsCode("NOGAM5"));
        dispatch(questionnaireActions.getAnswers("NOGAM5"));
        dispatch(questionnaireActions.getArea());
    }, []);


    useEffect(()=>{
        if(!assessment) return;
        dispatch(questionnaireActions.getResponses(assessment.assessment_id));
    }, [assessment])



    useEffect(() => {
        if (saveAnswer){
            setShowModal(false)

            setPoints(0);
            dispatch(questionnaireActions.getAssessmentsCode("NOGAM5"));
            dispatch(questionnaireActions.getAnswers("NOGAM5"));
        }
    },[saveAnswer])




    const updateValue = () => {
        dispatch(questionnaireActions.saveAnswer({
            points: points,
            assessment_id: modalItem.id
        }))

    }



    const openModal = (item) => {
        setPoints(getPoint(item))

        setModalItem(item);
        setShowModal(true);
        if(item.questionType==='SINGLE') {
            setAssessment(responses.find(res => res.assessment_id === item.id))
        }

    }


    const closeModal = () => {
        setShowModal(false)
    }


    const getPoint = (item) => {
        let mAnswer = answers.filter(it => it.assessment_id === item.id);
        if(!mAnswer.length) return 0;
        if (mAnswer[0]){
                if (item.questionType === "RATING" || item.questionType === "SINGLE"){
                    return mAnswer[0].points
                }
            if (item.questionType === "RATINGOB"){
                return mAnswer[0].yesno === 1 ?  t("yes") + ". " + mAnswer[0].points : t("no")
            }
        }else{
            return "";
        }

    }

    const saveAndContinue = () => {
        localStorage.removeItem(variables.LASTNOGAM5);
        history.push("/admin/assessment")
    }

    return (responses.length>0&&
            <>
                {showModal&&modalItem&&
                    <Modal
                        onOk={()=>updateValue()}
                        onCancel={()=>closeModal()}
                        visible={showModal}
                    >

                        <p>{modalItem.question.replace('{{vocArea}}',studentArea?.area?.name??'')}</p>
                        {modalItem.questionType==='SINGLE'&&responsesData?.length>0&&
                            <Radio.Group

                                onChange={(value)=>setPoints(value.target.value)}
                                value={points}
                                options={responsesData
                                    .map(response=>{
                                        return {
                                            label:response.question,
                                            value:response.id
                                        }})}>
                            </Radio.Group>
                        }

                    </Modal>
                }
                <div className={"backGroundCeiba"}>

                    <div className={"wrapper-question boxed"}>
                        <div className={"insideCeiba boxed"}>
                            <Headerbutton saveAndContinue={saveAndContinue} title={t("nogam5.header")}/>
                        </div>
                        <div className={"container-question container-question__end no-gamificado"}>
                            <div className={"container-question__auto-margin"}>
                                <div className={"question__header"}>
                                    <img className={"question__header-icon"} src={report}/>
                                    <h2>{t("nogam5.endtitle")}</h2>
                                </div>
                                <div className={"question__content"}>
                                    <div className={"question__content-list"}>
                                        {responses && data && data.map ( (item, index) => (
                                            <div className={"list-item"}>
                                                <div className={"list-item-l"}>
                                                    <p>{item.question.replace('{{vocArea}}',studentArea?.area?.name??'')}</p>
                                                </div>
                                                <div className={"list-item-r"}>
                                                    <p>{item.questionType==='SINGLE'?responses.find(res=>res.assessment_id===item.id)? responses.find(res=>res.assessment_id===item.id).question:getPoint(item):getPoint(item)}</p>
                                                    <div
                                                          className={"modifica"}
                                                          // ToDo : Funcionalidad de abrir Modal y de modificar la pregunta
                                                          onClick={() => openModal(item)}
                                                    >
                                                        {t("ceiba.modificar")}&nbsp;<EditOutlined/>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className={"question__content-bottom"}>
                                        {/* ToDo : poner funcionamiento de reiniciar cuestionario */}
                                        <div className="left">
                                            <Button
                                              icon={<ReloadOutlined />}
                                              type={"secondary"}
                                              className="primaryButton"
                                              onClick={() => history.push('/admin/nogam5?restart=true')}
                                            >
                                                {t("reset")}
                                            </Button>
                                        </div>
                                        <div className="right">
                                            <Button
                                              icon={<ArrowRightOutlined/>}
                                              onClick={() => history.push("/admin/assessment")}
                                              type={"primary"}
                                              className="primaryButton"
                                            >
                                                {t("tek.irahome")}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
    )

}
export default withTranslation()(EndNogam5);
